import { render, staticRenderFns } from "./DocumentMeta.vue?vue&type=template&id=595efba5&"
import script from "./DocumentMeta.vue?vue&type=script&lang=js&"
export * from "./DocumentMeta.vue?vue&type=script&lang=js&"
import style0 from "./DocumentMeta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports